import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { EtaDetailsService } from '../../realtime-tracking/shared/eta-details.service';
import { DataTableColumn, DataTableComponent } from '../data-table/data-table.component';
import { Observable, of } from 'rxjs';
import { SearchObjectResult } from '../search-object-result.model';
import { EtaDetail } from '../../realtime-tracking/shared/eta-detail.model';
import { EtaEmitter } from '../../realtime-tracking/shared/eta-emitter.enum';
import { DeliveryEventSource } from '../../realtime-tracking/shared/delivery-event-source.enum';
import { DeliveryEtaEventInitiatorUtil } from '../../realtime-tracking/shared/delivery-eta-event-initiator';
import { EtaDetailInput, EtaDetailInputsUtil } from '../../realtime-tracking/shared/eta-detail-input';
import { switchMap } from 'rxjs/operators';
import { StopType } from '../stop-type.model';

@Component({
  selector: 'app-eta-details-popup',
  templateUrl: './eta-details-popup.component.html',
  styleUrls: ['./eta-details-popup.component.scss']
})
export class EtaDetailsPopupComponent implements OnInit {

  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild(DataTableComponent, {static: true})
  etaDetailsTable: DataTableComponent;

  @ViewChild('sourceColumn', {static: true})
  sourceColumn: TemplateRef<any>;

  @ViewChild('etaColumn', {static: true})
  etaColumn: TemplateRef<any>;

  @ViewChild('sentToMyChepColumn', {static: true})
  sentToMyChepColumn: TemplateRef<any>;

  @ViewChild('geopositionColumn', {static: true})
  geopositionColumn: TemplateRef<any>;

  @ViewChild('expandDetailsColumn', {static: true})
  expandDetailsColumn: TemplateRef<any>;

  @Input() tripId!: string;
  @Input() deliveryNumber!: string;
  @Input() etaDestinationType: StopType;
  @Input() etaDestinationGlid: string;
  @Input() latestEtaReportId: string;
  columns: DataTableColumn[];

  protected readonly EtaEmitter = EtaEmitter;

  loadEtas: (...config) => Observable<SearchObjectResult<EtaDetail>> = this.getEtaFetchMethod();

  constructor(private etaDetailsService: EtaDetailsService) {}

  ngOnInit(): void {
    this.columns = [
      {
        name: 'source',
        displayed: true,
        translationKey: 'eta-details.source',
        template: this.sourceColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'eta',
        displayed: true,
        translationKey: 'eta-details.eta',
        template: this.etaColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'geoposition',
        displayed: true,
        translationKey: 'eta-details.coords',
        template: this.geopositionColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'sentToMyChep',
        displayed: true,
        translationKey: 'eta-details.sent-to-my-chep',
        template: this.sentToMyChepColumn,
        sortable: false,
        alignCenter: true,
      },
      {
        name: 'expandDetails',
        displayed: true,
        translationKey: '',
        template: this.expandDetailsColumn,
        sortable: false,
        alignCenter: true,
      }
    ];
  }

  private getEtaFetchMethod() {
    return () => of(null)
      .pipe(
        switchMap(() => {
            if (this.tripId) {
              return this.etaDetailsService.searchByTripId(this.tripId, this.etaDestinationType, 0, 1000, this.etaDestinationGlid)
            } else if (this.deliveryNumber) {
              return this.etaDetailsService.searchByDeliveryNumber(this.deliveryNumber, this.etaDestinationType, 0, 1000, this.etaDestinationGlid)
            } else {
              throw new Error('No delivery number or Trip Id to fetch eta details.')
            }
          }
        )
      );
  }

  isSelectedLoad(loadUuid: string): boolean {
    return this.etaDetailsTable.isSelected(this.getEtaInTable(loadUuid))
  }

  getEtaInTable(id: string) {
    return this.etaDetailsTable.items.find(eta => eta.id === id);
  }

  toggleDisplayEvents(id: string): void {
    const eta = this.getEtaInTable(id);
    this.etaDetailsTable.selectMultiItem(eta);
  }

  getInitiator(emitter: EtaEmitter, eventSource: DeliveryEventSource) {
    return DeliveryEtaEventInitiatorUtil.fromEmitterAndSource(emitter, eventSource);
  }

  calculateInputsForEtaDetail(item: EtaDetail): EtaDetailInput[] {
    return EtaDetailInputsUtil.fromEmitter(item.emitter, item.eventSource)
  }
}
